import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import i18n from '@/plugins/i18nPlugin'

import {
  mdiTranslate,
  mdiLogoutVariant,
  mdiInformationVariant,
  mdiDotsVertical,
  mdiAccountEditOutline,
  mdiLockReset
} from '@mdi/js'

Vue.use(Vuetify)

const plugin = new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
    values: {
      mdiTranslate,
      mdiLogoutVariant,
      mdiInformationVariant,
      mdiDotsVertical,
      mdiAccountEditOutline,
      mdiLockReset
    }
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#325d88',
        secondary: '#79858b',
        accent: '#009688',
        error: '#B71C1C',
        warning: '#f47c3c',
        info: '#00bcd4',
        success: '#1B5E20',
        'warninglevel-null': '#79858b',
        'warninglevel-0': '#79858b',
        'warninglevel-1': '#1DB312',
        'warninglevel-2': '#1DB312',
        'warninglevel-3': '#f47c3c',
        'warninglevel-4': '#f47c3c',
        'warninglevel-5': '#FF1500',
        'warninglevel-6': '#FF1500'
      }
    }
  },
  lang: {
    t: (key, ...params) => String(i18n.t(key, params))
  }
})

export default plugin
